// extracted by mini-css-extract-plugin
export default {"chooseShape":"index_chooseShape__8UCtK","item":"index_item__O3zPk","active":"index_active__I7L9u"};